module.exports = __webpack_public_path__ + "static/media/btn_connect_within_my_circle.39939ebb.png";